<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
const temp = ["合作社数量"];
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#0A1D31",
            },
          },
        },
        legend: {
          show: true,
          orient: "horizontal",
          icon:  "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAACXBIWXMAABcRAAAXEQHKJvM/AAABZklEQVQ4jZWU0W3CQBBEX1yAoYO4g6QDnA74ut+EDighJUAFMb/+CenAdGA6CB2Qa4BonD20HAYpIyEZ3+7s7N6sH06nE/dQ0tbAMRL6W2FXJCXtFFgCb8BjFv8FbCOhuUliVbfAxF7tpcKeK0e6A+aRcLwgKWnnwKeruIyE70ylijRGpgK1iAaSklZVelOwyOWOtNsBT1IUCXVhZ+9GsM4JVL2kfU7/rQUpOgAznScl575Tn9Ze4+ZzMYeSVoP/ADaF9anAzgVUGYEws6EnRUnxvHBB3gd1RuCJPKRuUlyF/WF69eYOPEnlnrc3UnYjyn6KSOhSb3Z9mD8WCnAJB3PyABu80CUlG5vBOcgGJ3Uv+kVClfbHiq0stPm32YxE56/JbN726d6FtQyYrtwl69akQG5Vq4Ov8gUUkYK8wTQzKZVrlSxob2S8YbfGPgVK0BpocLlXlLy6+ykY6V3Vk2f6vL0BwC+XKJpK80UTdwAAAABJRU5ErkJggg==",
          x: "right",
          y: "10",
          data: ["合作社数量"],
          itemWidth: 13,
          itemHeight:13,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 255, 169, 1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 255, 169, 0.15)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          textStyle: {
            color: "#62D9AD",
            fontSize: "12",
          },
        },
        grid: {
          right: "10",
          left: "15%",
          top: "15%",
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              color: "#62D9AD",
              fontSize: 12,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#62D9AD",
              },
              width: 1,
            },
            /*    axisLabel: {
            show: true,
            margin: '10',
            fontSize: '10',
            rotate: 45,
            textStyle: {
              color: '#ffffff' //X轴文字颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: '#96A4F4'
            },
            width: 5
          }, */

            data: ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
          },
        ],
        yAxis: {
          name: "单位(台)",
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 10,
          },
          axisLabel: {
            interval: 0,
            color: "#62D9AD",
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.chartData.regionProductionList = [{}];
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let xAxisData = [];
      let series = [];
      let data = [];
      if (this.chartData.regionProductionList) {
        for (
          let index = 0;
          index < this.chartData.regionProductionList.length;
          index++
        ) {
          const el = this.chartData.regionProductionList[index];
          let color = "";
          series.push({
            name: temp[index],
            type: "line",
            label: {
              show: false,
              position: "insideLeft",
              formatter(v) {
                if (v.value <= 0) {
                  return "";
                } else {
                  return v.value;
                }
              },
            },
            symbol: "path://M512,64c60.5,0,119.2,11.8,174.4,35.2,53.3,22.6,101.3,54.9,142.4,96,41.2,41.2,73.5,89.1,96,142.4C948.2,392.8,960,451.5,960,512s-11.8,119.2-35.2,174.4c-22.6,53.3-54.9,101.3-96,142.4-41.2,41.2-89.1,73.5-142.4,96C631.2,948.2,572.5,960,512,960s-119.2-11.8-174.4-35.2c-53.3-22.6-101.3-54.9-142.4-96-41.2-41.2-73.5-89.1-96-142.4C75.8,631.2,64,572.5,64,512s11.8-119.2,35.2-174.4c22.6-53.3,54.9-101.3,96-142.4s89.1-73.5,142.4-96C392.8,75.8,451.5,64,512,64m0-64C229.2,0,0,229.2,0,512s229.2,512,512,512,512-229.2,512-512S794.8,0,512,0z M512,512m-96,0a96,96,0,1,0,192,0,96,96,0,1,0-192,0Z",
            symbolSize: 8,

            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: "RGBA(13, 243, 160, 1)",
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: "rgba(13, 255, 169, .25)",
                    },
                    {
                      offset: 1,
                      color: "rgba(13, 255, 169, 0)",
                    },
                  ]
                ),
              },
            },
            data: [280, 233, 200, 450, 390, 330, 430, 332, 0],
            areaStyle: {},
          });
        }
        this.options.xAxis.data = this.chartData.regionList;
        this.options.series = series;
        this.chart.setOption(this.options);
      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
